// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .navigation-bar{
        height: 10%;
    }
    .navigation-bar nav{
        box-sizing: border-box;
        margin: 0px;
        height: 10%;
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 0px 50px;
        align-items: center;
        position:fixed;
        left: 0px;
        z-index: 10;
        background-color: rgba(155, 30, 30, 0.952);
    }
    .nav-header-container{
        display: flex;
        width: 16%;
        justify-content: space-between;
        align-items: center;
    }
    .application-title-container{
        color: white;
    }
    .application-title-container p{
        margin: 0px;
        font-size: 20px;
    }
    .mobile-side-bar-launcher{
        display: none;
    }
    .blink-logo{
        height: 7vh;
        cursor: pointer;
    }
    .user-and-notification-container{
        display: flex;
        align-items: center;
    }
    .notifications-container{
        margin-right: 20px;
        margin-top: 8px;
        position: relative;
    }
    .notification-icon{
        height: 4vh;
    }
    .notification-badge{
        color: red;
        background-color: white;
        position: absolute;
        top: -5px;
        right: -5px;
        padding: 1px 6px;
        border-radius: 50%;
    }
    .user-container{
        display: flex;
        color: white;
        font-size: 16px;
        min-width: 140px;
        cursor: pointer;
        position: relative;
    }
    .mobile-accounts-launcher{
        display: none;
    }
    .user-container p{
        margin: 2px;
    }
    .user-profile-picture{
        height: 50px;
        border-radius: 50%;
        margin-right: 15px;
    }
    .logout-and-account-div{
        position: absolute;
        top: 5.5vh;
        left: 70px;
        padding: 0px;
        border-radius: 6px;
        background-color: white;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
    .logout-and-account-div button{
        width: 100%;
        border: none;
        padding: 10px 30px;
        background-color: transparent;
        cursor: pointer;
        margin: 0px;
    }
    #account-button{
        border-radius: 6px 6px 0px 0px;
    }
    #logout-button{
        border-radius: 0px 0px 6px 6px;
    }
    .logout-and-account-div button:hover{
        background-color: lightgray;
    }
}
@media screen and (max-width:949px){
    .navigation-bar{
        height: 10%;
    }
    .navigation-bar nav{
        box-sizing: border-box;
        margin: 0px;
        height: 10vh;
        width: 100%;
        background-color: rgba(155, 30, 30, 0.952);
        display: flex;
        justify-content: space-between;
        padding: 0px 10px;
        align-items: center;
        position:fixed;
        left: 0px;
        z-index: 10;
    }
    .nav-header-container{
        display: flex;
        width: 10%;
        justify-content: space-between;
        align-items: center;
    }
    .application-title-container{
        color: white;
        margin-left: 2vw;
    }
    .application-title-container p{
        margin: 0px;
        font-size: 10px;
    }
    .mobile-side-bar-launcher div{
        width: 15px;
        margin-left: 10px;
        margin-right: 20px;
    }
    .mobile-side-bar-launcher p{
        width: 100%;
        margin: 5px 0px;
        border: 1px solid white;
    }
    .blink-logo{
        margin-left: 0px;
        height: 4vh;
        cursor: pointer;
    }
    .user-and-notification-container{
        display: flex;
        align-items: center;
    }
    .notifications-container{
        margin-right: 20px;
        margin-top: 8px;
        right: 5vw;
        position: absolute;
    }
    .notification-icon{
        height: 4vh;
    }
    .notification-badge{
        color: red;
        background-color: white;
        position: absolute;
        top: -5px;
        right: -5px;
        padding: 1px 6px;
        border-radius: 50%;
    }
    .user-container img{
        display: none;
    }
    .user-account-details-container{
        display: none;
    }
    .mobile-accounts-launcher div{
        width: 4px;
        height: 4px;
        border-radius: 50%;
        margin: 4px 5px;
        background-color: white;
    }
    .user-container p{
        margin: 2px;
    }
    .user-profile-picture{
        height: 50px;
        border-radius: 50%;
        margin-right: 15px;
    }
    .logout-and-account-div{
        position: absolute;
        top: 8vh;
        right: 2vw;
        padding: 0px;
        border-radius: 10px;
        background-color: white;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    }
    .logout-and-account-div button{
        width: 100%;
        border: none;
        padding: 10px 30px;
        background-color: transparent;
        cursor: pointer;
        margin: 0px;
    }
    #account-button{
        border-radius: 10px 10px 0px 0px;
    }
    #logout-button{
        border-radius: 0px 0px 10px 10px;
    }
    .logout-and-account-div button:hover{
        background-color: lightgray;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/NavigationBar.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;IACf;IACA;QACI,sBAAsB;QACtB,WAAW;QACX,WAAW;QACX,WAAW;QACX,aAAa;QACb,8BAA8B;QAC9B,iBAAiB;QACjB,mBAAmB;QACnB,cAAc;QACd,SAAS;QACT,WAAW;QACX,0CAA0C;IAC9C;IACA;QACI,aAAa;QACb,UAAU;QACV,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;QACV,uBAAuB;QACvB,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,UAAU;QACV,YAAY;QACZ,kBAAkB;QAClB,uBAAuB;QACvB,wCAAwC;IAC5C;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,6BAA6B;QAC7B,eAAe;QACf,WAAW;IACf;IACA;QACI,8BAA8B;IAClC;IACA;QACI,8BAA8B;IAClC;IACA;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,WAAW;QACX,0CAA0C;QAC1C,aAAa;QACb,8BAA8B;QAC9B,iBAAiB;QACjB,mBAAmB;QACnB,cAAc;QACd,SAAS;QACT,WAAW;IACf;IACA;QACI,aAAa;QACb,UAAU;QACV,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,WAAW;QACX,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,eAAe;QACf,uBAAuB;IAC3B;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,eAAe;IACnB;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,eAAe;QACf,UAAU;QACV,kBAAkB;IACtB;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;QACV,uBAAuB;QACvB,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,UAAU;QACV,WAAW;QACX,kBAAkB;QAClB,eAAe;QACf,uBAAuB;IAC3B;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;QACvB,sCAAsC;IAC1C;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,6BAA6B;QAC7B,eAAe;QACf,WAAW;IACf;IACA;QACI,gCAAgC;IACpC;IACA;QACI,gCAAgC;IACpC;IACA;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":["@media screen and (min-width:950px){\r\n    .navigation-bar{\r\n        height: 10%;\r\n    }\r\n    .navigation-bar nav{\r\n        box-sizing: border-box;\r\n        margin: 0px;\r\n        height: 10%;\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        padding: 0px 50px;\r\n        align-items: center;\r\n        position:fixed;\r\n        left: 0px;\r\n        z-index: 10;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n    }\r\n    .nav-header-container{\r\n        display: flex;\r\n        width: 16%;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .application-title-container{\r\n        color: white;\r\n    }\r\n    .application-title-container p{\r\n        margin: 0px;\r\n        font-size: 20px;\r\n    }\r\n    .mobile-side-bar-launcher{\r\n        display: none;\r\n    }\r\n    .blink-logo{\r\n        height: 7vh;\r\n        cursor: pointer;\r\n    }\r\n    .user-and-notification-container{\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .notifications-container{\r\n        margin-right: 20px;\r\n        margin-top: 8px;\r\n        position: relative;\r\n    }\r\n    .notification-icon{\r\n        height: 4vh;\r\n    }\r\n    .notification-badge{\r\n        color: red;\r\n        background-color: white;\r\n        position: absolute;\r\n        top: -5px;\r\n        right: -5px;\r\n        padding: 1px 6px;\r\n        border-radius: 50%;\r\n    }\r\n    .user-container{\r\n        display: flex;\r\n        color: white;\r\n        font-size: 16px;\r\n        min-width: 140px;\r\n        cursor: pointer;\r\n        position: relative;\r\n    }\r\n    .mobile-accounts-launcher{\r\n        display: none;\r\n    }\r\n    .user-container p{\r\n        margin: 2px;\r\n    }\r\n    .user-profile-picture{\r\n        height: 50px;\r\n        border-radius: 50%;\r\n        margin-right: 15px;\r\n    }\r\n    .logout-and-account-div{\r\n        position: absolute;\r\n        top: 5.5vh;\r\n        left: 70px;\r\n        padding: 0px;\r\n        border-radius: 6px;\r\n        background-color: white;\r\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n    }\r\n    .logout-and-account-div button{\r\n        width: 100%;\r\n        border: none;\r\n        padding: 10px 30px;\r\n        background-color: transparent;\r\n        cursor: pointer;\r\n        margin: 0px;\r\n    }\r\n    #account-button{\r\n        border-radius: 6px 6px 0px 0px;\r\n    }\r\n    #logout-button{\r\n        border-radius: 0px 0px 6px 6px;\r\n    }\r\n    .logout-and-account-div button:hover{\r\n        background-color: lightgray;\r\n    }\r\n}\r\n@media screen and (max-width:949px){\r\n    .navigation-bar{\r\n        height: 10%;\r\n    }\r\n    .navigation-bar nav{\r\n        box-sizing: border-box;\r\n        margin: 0px;\r\n        height: 10vh;\r\n        width: 100%;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        display: flex;\r\n        justify-content: space-between;\r\n        padding: 0px 10px;\r\n        align-items: center;\r\n        position:fixed;\r\n        left: 0px;\r\n        z-index: 10;\r\n    }\r\n    .nav-header-container{\r\n        display: flex;\r\n        width: 10%;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .application-title-container{\r\n        color: white;\r\n        margin-left: 2vw;\r\n    }\r\n    .application-title-container p{\r\n        margin: 0px;\r\n        font-size: 10px;\r\n    }\r\n    .mobile-side-bar-launcher div{\r\n        width: 15px;\r\n        margin-left: 10px;\r\n        margin-right: 20px;\r\n    }\r\n    .mobile-side-bar-launcher p{\r\n        width: 100%;\r\n        margin: 5px 0px;\r\n        border: 1px solid white;\r\n    }\r\n    .blink-logo{\r\n        margin-left: 0px;\r\n        height: 4vh;\r\n        cursor: pointer;\r\n    }\r\n    .user-and-notification-container{\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .notifications-container{\r\n        margin-right: 20px;\r\n        margin-top: 8px;\r\n        right: 5vw;\r\n        position: absolute;\r\n    }\r\n    .notification-icon{\r\n        height: 4vh;\r\n    }\r\n    .notification-badge{\r\n        color: red;\r\n        background-color: white;\r\n        position: absolute;\r\n        top: -5px;\r\n        right: -5px;\r\n        padding: 1px 6px;\r\n        border-radius: 50%;\r\n    }\r\n    .user-container img{\r\n        display: none;\r\n    }\r\n    .user-account-details-container{\r\n        display: none;\r\n    }\r\n    .mobile-accounts-launcher div{\r\n        width: 4px;\r\n        height: 4px;\r\n        border-radius: 50%;\r\n        margin: 4px 5px;\r\n        background-color: white;\r\n    }\r\n    .user-container p{\r\n        margin: 2px;\r\n    }\r\n    .user-profile-picture{\r\n        height: 50px;\r\n        border-radius: 50%;\r\n        margin-right: 15px;\r\n    }\r\n    .logout-and-account-div{\r\n        position: absolute;\r\n        top: 8vh;\r\n        right: 2vw;\r\n        padding: 0px;\r\n        border-radius: 10px;\r\n        background-color: white;\r\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .logout-and-account-div button{\r\n        width: 100%;\r\n        border: none;\r\n        padding: 10px 30px;\r\n        background-color: transparent;\r\n        cursor: pointer;\r\n        margin: 0px;\r\n    }\r\n    #account-button{\r\n        border-radius: 10px 10px 0px 0px;\r\n    }\r\n    #logout-button{\r\n        border-radius: 0px 0px 10px 10px;\r\n    }\r\n    .logout-and-account-div button:hover{\r\n        background-color: lightgray;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
